import thoughtful_traditionalist from '../assets/ai-readiness/thoughtful_traditionalist.svg'
import WhereYouAre from '../assets/ai-readiness/where_you_are.svg'
import AiImpact from '../assets/ai-readiness/ai_impact.svg'
import SchoolAiSupport from '../assets/ai-readiness/schoolai_support.svg'
import ai_ready_innovator from '../assets/ai-readiness/ai_ready_innovator.svg'
import progressive_explorer from '../assets/ai-readiness/progressive_explorer.svg'
import data_driven_improver from '../assets/ai-readiness/data_driven_improver.svg'

export const aiReadinessOutcomes = [
  {
    id: 0,
    outcome_id: "550e8400-e29b-41d4-a716-446655440001",
    title: "The Thoughtful Traditionalist",
    description: "Your school values strong teacher–student relationships and time-tested teaching methods. Classrooms run on consistency, discipline and human connection. You believe great learning starts with great teaching. With School.AI, tradition gains the power of intelligent support.",
    buttonText: "Get your demo",
    gradient: "linear-gradient(135deg, #7E46CC 0%, #EC4899 100%)",
    mainImage: {
      component: thoughtful_traditionalist,
      alt: "The Thoughtful Traditionalist illustration"
    },
    sections: [
      {
        id: 1,
        title: "Where you are:",
        bullets: [
          "Strong teacher–student connection remains your school's strength.",
          "Classroom systems are stable, consistent, and built on proven methods.",
          "Focus stays on human interaction and academic discipline."
        ],
        image: {
          component: WhereYouAre,
          alt: "Where you are illustration"
        }
      },
      {
        id: 2,
        title: "Where AI can make an impact:",
        bullets: [
          "Reduce teachers' manual workload through automation.",
          "Identify learning gaps early with smart analytics.",
          "Collaborate with teacher and make personalised learning experience for students"
        ],
        image: {
          component: AiImpact,
          alt: "Where AI can make an impact illustration"
        }
      },
      {
        id: 3,
        title: "How SchoolAi supports you:",
        bullets: [
          "Automates homework creation and tracking.",
          "Provides instant student insights without changing classroom flow.",
          "Lets teachers focus more on teaching, not manual time taking tasks."
        ],
        image: {
          component: SchoolAiSupport,
          alt: "How SchoolAI supports you illustration"
        }
      }
    ]
  },
  {
    id: 1,
    outcome_id: "550e8400-e29b-41d4-a716-446655440004",
    title: "The AI-Ready Innovator",
    description: "Your school leads with vision and embraces transformation. Innovation isn't an experiment, it's your everyday practice. You're preparing students for a future powered by intelligence. With School.AI, your vision becomes an ecosystem of smart learning.",
    buttonText: "Get your demo",
    gradient: "linear-gradient(90deg, #7E46CC 21.94%, #DEA83B 51.52%)",
    mainImage: {
      component: ai_ready_innovator,
      alt: "The AI-Ready Innovator"
    },
    sections: [
      {
        id: 1,
        title: "Where you are:",
        bullets: [
          "Actively driving innovation and digital transformation.",
          "Clear vision for AI in classrooms and leadership.",
          "Preparing students for a technology-powered future."
        ],
        image: {
          component: WhereYouAre,
          alt: "Where you are illustration"
        }
      },
      {
        id: 2,
        title: "Where AI can make an impact:",
        bullets: [
          "Deepen personalisation and self-paced learning.",
          "Deliver real-time, actionable feedback.",
          "Create scalable systems that maintain quality at scale."
        ],
        image: {
          component: AiImpact,
          alt: "Where AI can make an impact illustration"
        }
      },
      {
        id: 3,
        title: "How SchoolAi supports you:",
        bullets: [
          "Acts as your school’s all-in-one AI infrastructure.",
          "Offers proven AI Tutor for students and AI Assistant for teachers.",
          "Gives leaders and parents live dashboards for learning progress."
        ],
        image: {
          component: SchoolAiSupport,
          alt: "How SchoolAI supports you illustration"
        }
      }
    ]
  },
  {
    id: 2,
    outcome_id: "550e8400-e29b-41d4-a716-446655440002",
    title: "The Progressive Explorer",
    description: "Your school leads with vision and embraces transformation. Innovation isn't an experiment, it's your everyday practice. You're preparing students for a future powered by intelligence. With School.AI, your vision becomes an ecosystem of smart learning.",
    buttonText: "Get your demo",
    gradient: "linear-gradient(90deg, #7E46CC 25.3%, #459CCA 59.42%)",
    mainImage: {
      component: progressive_explorer,
      alt: "The Progressive Explorer"
    },
    sections: [
      {
        id: 1,
        title: "Where you are:",
        bullets: [
          "Open to innovation and experimenting with digital tools.",
          "Teachers already use online resources, apps, or question banks.",
          "Mindset is growth-oriented and adaptive to change."
        ],
        image: {
          component: WhereYouAre,
          alt: "Where you are illustration"
        }
      },
      {
        id: 2,
        title: "Where AI can make an impact:",
        bullets: [
          "Turn your digital content and resources into truly adaptive learning experiences.",
          "Move beyond simple scores to offer instant, rich feedback and smart, actionable reporting.",
          "Enable leadership to move from historical analysis to faster, data-driven, and strategic decisions."
        ],
        image: {
          component: AiImpact,
          alt: "Where AI can make an impact illustration"
        }
      },
      {
        id: 3,
        title: "How SchoolAi supports you:",
        bullets: [
          "Builds directly on your existing tools and workflows, making the transition effortless.",
          "Personalizes learning for every student, making it a 1:1 experience and simplifies complex reporting for educators.",
          "Provides leaders with essential real-time dashboards and teachers with lesson tools carefully crafted by a 30+ year experienced education team, ensuring quality and pedagogical relevance."
        ],
        image: {
          component: SchoolAiSupport,
          alt: "How SchoolAI supports you illustration"
        }
      }
    ]
  },
  {
    id: 3,
    outcome_id: "550e8400-e29b-41d4-a716-446655440003",
    title: "The Data-Driven Improver",
    description: "Your school believes data drives better decisions. Teachers use systems and insights to improve every outcome. You focus on progress that’s measurable and meaningful. With School.AI, data turns into real-time action and smarter results.",
    buttonText: "Get your demo",
    gradient: "linear-gradient(90deg, #7E46CC 29.81%, #FF7640 70%)",
    mainImage: {
      component: data_driven_improver,
      alt: "The Data-Driven Improver"
    },
    sections: [
      {
        id: 1,
        title: "Where you are:",
        bullets: [
          "Using LMS and tracking systems effectively.",
          "Teachers are comfortable with data and digital workflows.",
          "Focused on improving outcomes using insights."
        ],
        image: {
          component: WhereYouAre,
          alt: "Where you are illustration"
        }
      },
      {
        id: 2,
        title: "Where AI can make an impact:",
        bullets: [
          "Shift from collecting and analyzing data to taking smart, immediate action based on real-time findings.",
          "Auto-generate personalized homework and deliver instant, targeted student feedback without teacher effort.",
          "Predict learning gaps and student struggles, well before formal assessment."
        ],
        image: {
          component: AiImpact,
          alt: "Where AI can make an impact illustration"
        }
      },
      {
        id: 3,
        title: "How SchoolAi supports you:",
        bullets: [
          "Extends school support to the home with an AI-Tutor, providing students with AI-powered learning beyond the classroom.",
          "Understands individual learning paths and personalizes resources for every student, addressing gaps immediately and effectively.",
          "Empowers teachers with predictive insights for each student, enabling targeted interventions that lift the class average."
        ],
        image: {
          component: SchoolAiSupport,
          alt: "How SchoolAI supports you illustration"
        }
      }
    ]
  }
];
